import mobileListService from "../../../service/mobile/MobileListService";
import constants from 'Constants';

class MobileGroupDomHandler {

    enableHandlers(container) {
        const items = container.querySelectorAll('.mobile-group-handler-disabled');
        Array.from(items).forEach(item => {
            item.removeAttribute('class');
            item.classList.add('mobile-group-handler-enabled');
        });
    }

    disableHandlers() {
        const items = document
            .querySelectorAll('.mobile-group-handler-enabled, ' +
                '.mobile-group-handler-selected');
        Array.from(items).forEach(item => {
            item.removeAttribute('class');
            item.classList.add('mobile-group-handler-disabled')
        });
    }

    selectHandlers(handler) {
        handler.removeAttribute('class');
        handler.classList.add('mobile-group-handler-selected')
    }

    isGroupItemHandler(target) {

        if(target){
            return target.classList.contains('mobile-group-handler-disabled') ||
            target.classList.contains('mobile-group-handler-enabled');
        }
        return 0;
    }


    isDroppingSameGroup(id, sourceId) {
        const groupId = id.replace('groupItems', '');
        const dropItem = mobileListService.getMobileControl(sourceId);
        return dropItem.groupId === groupId;
    }

    sortGroupControlItems(controlId) {
        const control = mobileListService.getMobileControl(controlId);
        if (control) {
            let controlContainer = control.$el.find(`#${controlId}`);
            let element = controlContainer.find(".pf-control-core");
            const itemsContainer = element.find('[id^=\'groupItems\']').children();
            let childList  = [];
            itemsContainer.forEach(item => {
                const childFound = Array.from(control.mode.get('childList')).find(child => child.id === item.id);
                childList.push(childFound);
                control.model.set('childList', childList, constants.MODEL_SILENT);
            });
        }
    }

    onDropGroupItem(event) {
        event.originalEvent.preventDefault();
        event.originalEvent.stopPropagation();
        const data = JSON.parse(event.originalEvent.dataTransfer.getData(constants.TYPE_TEXT));
        if (data) {
            let parameters = data[0];
            const target = event.currentTarget;
            if (target.parentElement.id && this.isDroppingSameGroup(target.parentElement.id, parameters.sourceId)) {
                if (parameters.sourceId !== event.currentTarget.parentElement.id ) {
                    let oldNode = target.parentElement.querySelector(`[id^=\'${parameters.sourceId}\']`);
                    let newNode = Object.assign(oldNode);
                    if (target.previousElementSibling && target.nextElementSibling && target.previousElementSibling.id !== parameters.sourceId) {
                        oldNode.parentNode.removeChild(oldNode);
                        target.before(newNode);
                    } else if (target.previousElementSibling && !target.nextElementSibling && target.previousElementSibling.id !== parameters.sourceId) {
                        oldNode.parentNode.removeChild(oldNode);
                        target.after(newNode);
                    } else if (target.previousElementSibling && target.previousElementSibling.id === parameters.sourceId) {
                        oldNode.parentNode.removeChild(oldNode);
                        target.after(newNode);
                    } else {
                        oldNode.parentNode.removeChild(oldNode);
                        target.before(newNode);
                    }
                    this.sortGroupControlItems();
                }
            }
        }
    }

}

const mobileGroupDomHandler = new MobileGroupDomHandler();
export default mobileGroupDomHandler;